export default {
  serverProtocol: 'https',
  serverIp: 'blobs.kr',
  serverPort: '10003',
  serverContext: 'coin',
};
